import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyWidgetTraining" })
export default class MyWidgetTraining extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public data: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;
        this.data = (await Axios.post(this.routes.MyBremboPartsDashboard_GetWidgetTrainingData, null)).data;
        this.isLoading = false;
    }

    public formatDate(dateItem: string): string {
        if (dateItem == null) {
            return "";
        }

        let date = new Date(dateItem);
        return date.toLocaleString((<any>window).App.culture, {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit"
        });
    }
};